import { Component } from '@angular/core';

@Component({
  selector: 'app-random-words',
  templateUrl: './random-words.component.html',
  styleUrls: ['./random-words.component.scss'],
})
export class SessionModulesRandomWordsComponent {}
